import styled from 'styled-components';

export const HttpsText = styled.p`
  font-size: 16px;
  color: ${props => props.theme.interface5};
  line-height: 150%;
`;
